<template>
  <Navbar>
    <template #start>
      <Breadcrumb>
     
	<BreadcrumbItem
	  v-for="({ to, label }, index) in levels"
	  :key="index"
	  :to="to"
	>
	  {{ label }}
	</BreadcrumbItem>
      </Breadcrumb>
    </template>
    <template #end>
      <BrowserNavigationPager
	@input="handlePager"
	:value="pageNum"
	:max="totalPages"
      />
    </template>
  </Navbar>
</template>

<style>
 .level.is-fullwidth {
   width: 100%;
 }

 .has-shadow {
   box-shadow: 0 2px 0 0 whitesmoke;
 }
</style>

<script>
 import Navbar from '@/components/Navbar.vue'
 import Breadcrumb from '@/components/Breadcrumb.vue'
 import BreadcrumbItem from '@/components/BreadcrumbItem.vue'
 import BrowserNavigationPager from '@/components/BrowserNavigationPager.vue'

 import { createNamespacedHelpers } from 'vuex'

 const { mapState } = createNamespacedHelpers('browser')

 import { createMapper } from '@/utils/mapping.js'

 const mapper = createMapper('browser')

 export default {
   components: {
     Navbar,
     Breadcrumb,
     BreadcrumbItem,
     BrowserNavigationPager
   },
   data() {
     return {
       document: null
     }
   },
   computed: {
     isReady() {
       return this.document !== null
     },
     pageNum() {
       return parseInt(this.$route.params.pageNum)
     },
     searchTerm() {
       return mapper.fromURL(this.$route.query).term || ''
     },
     totalPages() {
       return this.document === null ? 0 : this.document.pageCount
     },
     levels() {
       const home = { to: { name: 'Home' }, label: "Home" }
       if (!this.isReady) {
	 return [home]
       }
       else {
	 const levels = [
	   home,
	   {
	     to: {
	       name: 'StaticDirectory'
	     },
	     label: this.$t('Browse')
	   },
	   {
	     to: {
	       name: 'Document',
	       params: {
		 documentId: this.document.id
	       }
	     },
	     label: this.document.title
	   }
	 ]
	 return levels
       }
     }
   },
   async mounted() {
     this.document = await this.api.fetchDocument(this.$route.params.documentId)
   },
   methods: {
     handlePager(value) {
       this.$router.push({
	 params: {
	   ...this.$route.params,
	   pageNum: value
	 },
	 query: {
	   ...this.$route.query
	 }
       })
     }
   }
 }
</script>
